const SMALL = 'Small';
const MEDIUM = 'Medium';
const LARGE = 'Large';

export default {
  SMALL,
  MEDIUM,
  LARGE,
};
